




























































import teipTableMixin from '@/mixins/teipTableMixinVueExtends';
import Vue from 'vue';

export default Vue.extend({
  name: 'TeipTable',
  mixins: [teipTableMixin],
  props: {
    trigger: {
      required: false,
      default: 'click',
      type: String,
    },
  },
});
